import { Switch } from "@mimber/ui-web"
import { FormItem } from "react-hook-form-antd"
import { useFormContext, FieldValues, FieldPath } from "react-hook-form"
import type { SwitchFieldProps } from "./SwitchField.types"

/**
 * SwitchField component that integrates React Hook Form with Ant Design Switch
 * Uses react-hook-form-antd's FormItem for seamless integration
 *
 * Note: FormItem handles the checked/onChange binding automatically for Switch.
 */
export function SwitchField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  control,
  label,
  required,
  help,
  description,
  disabled,
  size,
  checkedChildren,
  unCheckedChildren,
  loading,
}: SwitchFieldProps<TFieldValues, TName>) {
  const { control: contextControl } = useFormContext<TFieldValues>()
  const formControl = control || contextControl

  return (
    <FormItem
      control={formControl}
      name={name}
      label={label}
      required={required}
      help={help ?? description}
      valuePropName="checked"
    >
      <Switch
        disabled={disabled}
        size={size}
        checkedChildren={checkedChildren}
        unCheckedChildren={unCheckedChildren}
        loading={loading}
      />
    </FormItem>
  )
}
